import axios from 'axios';

axios.defaults.withCredentials = true;

// QCUR: Question Columns, User Rows
export const getQcurData = payload => {
  let url = `${process.env.VUE_APP_API_URL}reporting/questionUserReport`;

  return axios
    .post(url, payload)
    .then(response => {
      return formatQcurData(response.data.orgSurveyQuestions, response.data.userResponseResults);
    });
}

export const getRpData = payload => {
  let url = `${process.env.VUE_APP_API_URL}reporting/responsePercentagesReport`;

  return axios
    .post(url, payload)
    .then(response => {
      return formatRpData(response.data.questionResponseResults)
    });
}

export const getTrData = payload => {
  let url = `${process.env.VUE_APP_API_URL}reporting/textResponsesReport`;

  return axios
    .post(url, payload)
    .then(response => {
      return formatTrData(response.data.textResponses)
    });
}

export const getReportLinks = payload => {
  let url = `${process.env.VUE_APP_API_URL}reporting/reportLinks`;

  return axios
    .post(url, payload)
    .then(response => {
      return response.data.reportLinks
    });
}

function formatQcurData(questions, userResults) {
  let rowDef = {};
  let questionsFormatted = questions.map(
    q => {
      if(q.hspQuestionTypeId === 2) {
        let subDef = q.responses.map(r => {
          let headerName = `Q${q.hspCategoryQuestionId}_${r.hspResponseId}`;
          rowDef[headerName] = 0;

          return {
            headerName: headerName,
            field: headerName,
            resizable: true
          }
        });

        return subDef;
      }
      else {
        let headerName = `Q${q.hspCategoryQuestionId}`;
        rowDef[headerName] = 0;

        return {
          headerName: headerName,
          field: headerName,
          resizable: true
        }
      }
    }
  ).flat();
  let columnDefs = [{
    headerName: 'User ID',
    field: 'orgSurveyUserId',
    resizable: true
  }, ...questionsFormatted]

  let rowData = [];
  userResults.forEach(ur => {
    let response = Object.assign({}, rowDef);

    response['orgSurveyUserId'] = ur.orgSurveyUserId;

    ur.responses.forEach(r => {
      let prop = `Q${r.hspCategoryQuestionId}`;
      let val;

      if(r.hspQuestionTypeId === 2) {
        prop += `_${r.hspResponseId}`;
        val = 1;
      }
      else {
        val = r.responseOrdinal;
      }

      if(r.hspResponseId === null || (r.hspResponseTypeId === 2 || r.hspResponseTypeId === 3)) {
        val = r.responseTextValue;
      }

      response[prop] = val;
    })

    rowData.push(response);
  });

  return {
    columnDefs: columnDefs,
    rowData: rowData
  }
}

function textFormatter(params) {
  if (!params.value) return "";
  
  return params.value;
}

function formatRpData(results) {
  const columnDefs = { 
    html: [
      {
        headerName: 'Section ID',
        field: 'HspSectionId',
        resizable: true
      },
      {
        headerName: 'Section',
        field: 'SectionTitle',
        resizable: true
      },
      {
        headerName: 'Parent Question',
        field: 'ParentQuestionText',
        cellRenderer: textFormatter,
        resizable: true
      },
      {
        headerName: 'Question ID',
        field: 'HspCategoryQuestionId',
        resizable: true
      },
      {
        headerName: 'Question',
        field: 'QuestionText',
        cellRenderer: textFormatter,
        resizable: true
      },
      {
        headerName: 'Response ID',
        field: 'HspResponseId',
        resizable: true
      },
      {
        headerName: 'Response',
        field: 'ResponseTitle',
        cellRenderer: textFormatter,
        resizable: true
      },
      {
        headerName: 'Count',
        field: 'ResponseCount',
        resizable: true
      }
    ],
    text: [
      {
        headerName: 'Section ID',
        field: 'HspSectionId',
        resizable: true
      },
      {
        headerName: 'Section',
        field: 'SectionTitle',
        resizable: true
      },
      {
        headerName: 'Parent Question',
        field: 'ParentQuestionText',
        resizable: true
      },
      {
        headerName: 'Question ID',
        field: 'HspCategoryQuestionId',
        resizable: true
      },
      {
        headerName: 'Question',
        field: 'QuestionText',
        resizable: true
      },
      {
        headerName: 'Response ID',
        field: 'HspResponseId',
        resizable: true
      },
      {
        headerName: 'Response',
        field: 'ResponseTitle',
        resizable: true
      },
      {
        headerName: 'Count',
        field: 'ResponseCount',
        resizable: true
      }
    ]
  };

  const rowData = results.map(result => {
    return {
      'HspSectionId': result.hspSectionId,
      'SectionTitle': result.sectionTitle,
      'ParentQuestionText': result.parentQuestionText,
      'HspCategoryQuestionId': result.hspCategoryQuestionId,
      'QuestionText': result.questionText,
      'HspResponseId': result.hspResponseId,
      'ResponseTitle': result.responseTitle,
      'ResponseCount': result.responseCount
    };
  })

  return {
    columnDefs: columnDefs,
    rowData: rowData
  }
}

function formatTrData(results) {
  const columnDefs = {
    html: [
      {
        headerName: 'Section ID',
        field: 'HspSectionId',
        resizable: true
      },
      {
        headerName: 'Section',
        field: 'SectionTitle',
        resizable: true
      },
      {
        headerName: 'Parent Question',
        field: 'ParentQuestionText',
        cellRenderer: textFormatter,
        resizable: true
      },
      {
        headerName: 'Question ID',
        field: 'HspCategoryQuestionId',
        resizable: true
      },
      {
        headerName: 'Question',
        field: 'QuestionText',
        cellRenderer: textFormatter,
        resizable: true
      },
      {
        headerName: 'Response ID',
        field: 'HspResponseId',
        resizable: true
      },
      {
        headerName: 'Response',
        field: 'ResponseTitle',
        cellRenderer: textFormatter,
        resizable: true
      },
      {
        headerName: 'Text Value',
        field: 'ResponseTextValue',
        resizable: true
      }
    ],
    text: [
      {
        headerName: 'Section ID',
        field: 'HspSectionId',
        resizable: true
      },
      {
        headerName: 'Section',
        field: 'SectionTitle',
        resizable: true
      },
      {
        headerName: 'Parent Question',
        field: 'ParentQuestionText',
        resizable: true
      },
      {
        headerName: 'Question ID',
        field: 'HspCategoryQuestionId',
        resizable: true
      },
      {
        headerName: 'Question',
        field: 'QuestionText',
        resizable: true
      },
      {
        headerName: 'Response ID',
        field: 'HspResponseId',
        resizable: true
      },
      {
        headerName: 'Response',
        field: 'ResponseTitle',
        resizable: true
      },
      {
        headerName: 'Text Value',
        field: 'ResponseTextValue',
        resizable: true
      }
    ]
  };

  const rowData = results.map(result => {
    return {
      'HspSectionId': result.hspSectionId,
      'SectionTitle': result.sectionTitle,
      'ParentQuestionText': result.parentQuestionText,
      'HspCategoryQuestionId': result.hspCategoryQuestionId,
      'QuestionText': result.questionText,
      'HspResponseId': result.hspResponseId,
      'ResponseTitle': result.responseTitle,
      'ResponseTextValue': result.responseTextValue
    };
  })

  return {
    columnDefs: columnDefs,
    rowData: rowData
  }
}
